module.exports = __webpack_public_path__ + "img/download-wizard.a2726754.png";